$(document).ready(function () {
  const priceInput = $('#Filter-Price-GTE, #Mobile-Filter-Price-GTE');
  const totalprice = $('#Filter-Price-LTE, #Mobile-Filter-Price-LTE');

  function minPriceChange(){
    $('#price-min').val($('#Filter-Price-GTE').val());
    $('#mobile-price-min').val($('#Mobile-Filter-Price-GTE').val());
  }
  function maxPriceChange(){
    $('#price-max').val($('#Filter-Price-LTE').val());
    $('#mobile-price-max').val($('#Mobile-Filter-Price-LTE').val());
  }

  function triggerSearchAfterDelay() {
    setTimeout(function () {
      $('input#search-bar').keyup();
    }, 1700);
  }

  $(document).on("change", '#price-min', function (e) {
    var updateValueMin = $('#price-min').val();
    console.log(updateValueMin, "updateValueMin")
    if (priceInput.length){ $('#Filter-Price-GTE').val(updateValueMin);}    
    $('#min-value').text(updateValueMin);
    $('#Filter-Price-GTE').trigger("change");
    // $('input#mobile-price-min').val(updateValueMin)
    triggerSearchAfterDelay();
  });

  $(document).on("change", '#price-max', function (e) {
    var updateValueMax = $('#price-max').val();
    if (totalprice.length) {$('#Filter-Price-LTE').val(updateValueMax);}
    $('#max-value').text(updateValueMax);
    $('#Filter-Price-LTE').trigger("change");
    triggerSearchAfterDelay();
  });

  // Mobile device range slider
  $(document).on("change", '#mobile-price-min', function (e) {
    var updateValueMinMob = $('#mobile-price-min').val();
    console.log(updateValueMinMob, "updateValueMinMob")
    console.log(priceInput, "priceInput")
    if (priceInput.length){$('#Mobile-Filter-Price-GTE').val(updateValueMinMob);}
    $('.mobile-ui-content #min-value').text(updateValueMinMob);
    // minPriceChange();
    triggerSearchAfterDelay();
  });
  $(document).on("change", '#mobile-price-max', function (e) {
    var updateValueMaxMob = $('#mobile-price-max').val();
    if (totalprice.length) {$('#Mobile-Filter-Price-LTE').val(updateValueMaxMob);}
    $('.mobile-ui-content #max-value').text(updateValueMaxMob);
    triggerSearchAfterDelay();
  });
});

// Js Convert to jQuery
$(document).ready(function () {
  const $searchBar = $('#search-bar');
  var $mainProductGrid = $('.product-grid-container .collection > ul');
  var $dupl_ProductGrid = $('.collection-hidden-products');

  // Update grid visibility based on search query
  function updateGridVisibility() {
    var $mainProductGrid = $('.product-grid-container .collection > ul');
    var $dupl_ProductGrid = $('.collection-hidden-products');
    if ($searchBar.val().trim() !== "") {
      $mainProductGrid.hide();
      $dupl_ProductGrid.css('display', 'flex');
    } else {
      $mainProductGrid.css('display', 'flex');
      $dupl_ProductGrid.hide();
    }
  }

  $mainProductGrid.css('display', 'flex');
  $dupl_ProductGrid.hide();
  let isErrorMessage = false;
  
  $searchBar.on('keyup', function(ev) {
    ev.preventDefault();
    const query = $searchBar.val().toLowerCase();
    let resultCount = 0;

    // Get all product cards (dynamically after page load)
    const $products = $('.card--standard');
    // Loop through each product card
    $products.each(function () {
      const $product = $(this);
      const titleElement = $product.find('.card__heading a');
      if (titleElement.length) {
        const title = titleElement.text().toLowerCase();
        if (title.includes(query)) {
          $product.show();
          $product.closest('.grid__item').show();
          $('.collection-hidden-products').siblings('.pagination-wrapper').hide();
          resultCount += 1;
        } else {
          isErrorMessage = true;
          $product.hide();
          $product.closest('.grid__item').hide();
          $('.collection-hidden-products').siblings('.pagination-wrapper').hide();
        }
      }
    });
    
    if (query === '') {
      $('.collection-hidden-products').siblings('.pagination-wrapper').show();
    }
    if (query !== '' && isErrorMessage && resultCount < 1) {
      $('.errroMessage').text('Search result not found').addClass('activeError');
    } else {
      $('.errroMessage').text('').removeClass('activeError');
    }
    updateGridVisibility();
  });
  
  // Select the parent container of all the buttons
  const $activeFacetsContainer = $(".facets .active-facets");
  if ($activeFacetsContainer.length) {
    $(document).on('click', '.active-facets__button, .active-facets__button-remove', function () {
      updateGridVisibility();
      setTimeout(function(){
        $('input#search-bar').keyup();
      }, 1500)
    });
  }

  // Sort filter Change event
  $(document).on('change', '#FacetSortForm #SortBy, #SortBy-mobile', function() {
    setTimeout(function(){
      $('input#search-bar').keyup();
    }, 2600);
  });
  
  $(document).on("click", '.facets__label', function(e) {
    console.log('Clicked on filters')
    setTimeout(function(){
      $('input#search-bar').keyup();
    }, 2000);
  });
});

// JQuery script ends

// document.addEventListener("DOMContentLoaded", function () {
//   const searchBar = document.getElementById("search-bar");
//   const productsIn = document.querySelectorAll(".card--standard"); // Use the class for your product card.

//   searchBar.addEventListener("keyup", function () {
//     const query = searchBar.value.toLowerCase();

//     productsIn.forEach(function (product) {
//       const title = product.querySelector(".card__heading a").innerText.toLowerCase(); // Update to your title selector.
//       if (title.includes(query)) {
//         product.closest('.grid__item').style.display = "block";
//         product.style.display = "block";
//       } else {
//         product.closest('.grid__item').style.display = "none";
//         product.style.display = "none"; 
//       }
//     });
//   });
// });


// On mobile device other sort filter remove
$(document).ready(function () {
  $(window).on("resize", function (e) {
    checkScreenSize();
  });
  checkScreenSize();
  function checkScreenSize(){
    var newWindowWidth = $(window).width();
    if (newWindowWidth < 767) {
     $(document).on("click", '.mobile_sort select#SortBy', function (e) {
      $('.custom_sort facet-filters-form.facets.facets-vertical-sort').remove();
    });
    }
    
  }
});



